import * as React from 'react';
import { FileIcon } from 'react-file-utils';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt';
import moment from 'moment';

import { useTheme } from '@mui/material';

import InsertCommentIcon from '@mui/icons-material/InsertComment';
import ReplyIcon from '@mui/icons-material/Reply';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from '@mui/material/Alert';
import Linkify from 'react-linkify';

import TopLevelCommentItem from './TopLevelCommentItem';

import {
  StreamApp,
  StatusUpdateForm,
  FlatFeed,
  NotificationDropdown,
  Activity,
  ActivityProps,
  ActivityFooter,
  Gallery,
  GalleryProps,
  LikeButton,
  CommentField,
  CommentList,
  CommentItem,
  InfiniteScrollPaginator,
} from 'react-activity-feed';

import TigerLikeButton from './TigerLikeButton';
import TigerCommentField from './TigerCommentField';
import extractFileNameFromStreamUrl from '../../utils/extractFileNameFromStreamUrl';
import extractFileExtensionFromUrl from '../../utils/extractFileExtensionFromUrl';
import { fileTypeFromFile } from 'file-type';
// import mime from 'mime';
// import * as mime from 'mime-types';

export type Tiger21ActivityProps = {
  activity: any;
};

// interface ExpandMoreProps extends IconButtonProps {
//   expand: boolean;
// }

// const ExpandMore = styled((props: ExpandMoreProps) => {
//   const { expand, ...other } = props;
//   return <IconButton {...other} />;
// })(({ theme, expand }) => ({
//   transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
//   marginLeft: 'auto',
//   transition: theme.transitions.create('transform', {
//     duration: theme.transitions.duration.shortest,
//   }),
// }));

export function Tiger21Activity({ activity }: Tiger21ActivityProps) {
  // React.useEffect(() => {
  // TODO change "Load more" to "View previous comments"
  // But only when `LoadMorePaginator and LoadMoreButton` are used in comment threads
  // const commentThreadElement = document.getElementsByClassName('tiger-comments-thread')[0];
  // const commentsLoadMoreButton = commentThreadElement.getElementsByClassName('raf-load-more-button');
  // });

  const [expanded, setExpanded] = React.useState(true);

  const { palette } = useTheme();

  const handleExpandClick = () => {
    console.log('TODO how should comment and reply button differ?');
    // setExpanded(!expanded);
  };

  const handleMainPostReply = () => {
    console.log('TODO handleMainPostReply');

    // TODO temp scroll to bottom, then useRef

    // DONT indiscrimately scroll to window bottom
    // window.scroll({
    //   top: document.body.offsetHeight,
    //   left: 0,
    //   behavior: 'smooth',
    // });
    // setExpanded(!expanded);
  };

  if (activity.settings?.postType === 'post') {
    return (
      <>
        <Card
          sx={{
            // maxWidth: 780,
            minWidth: 400,
            marginBottom: 5,
            border: 1,
            borderColor: palette.primary.main,
          }}
          variant='outlined'
        >
          <CardHeader
            avatar={
              <Avatar
                alt={activity.actor.data.name}
                src='/static/images/avatar/1.jpg'
                //   src={activity.actor.data.null}
              />
            }
            action={
              <IconButton aria-label='settings'>
                <MoreVertIcon />
              </IconButton>
            }
            title={activity.actor.data.name}
            subheader={moment(activity.time).fromNow()}
          />
          {/* TODO Show media only if Images, Videos, or Files are present */}
          {/* <CardMedia
          component='img'
          height='194'
          image='https://placehold.jp/e51f33/ffffff/1080x1080.png'
          alt='Paella dish'
        /> */}
          <CardContent>
            <Typography variant='h6'>{activity.subject}</Typography>
            <Typography variant='body2'>
              <Linkify>{activity.body}</Linkify>
            </Typography>
            {!!activity.attachments?.files?.length && (
              <ol className='raf-activity__attachments'>
                {console.log(
                  'debug attachments are ....',
                  activity.attachments
                )}
                {activity.attachments?.files.map(
                  (fileItem: string, fileIndex: number) => {
                    console.log('file is ...', fileItem);
                    const fileName = extractFileNameFromStreamUrl(fileItem);
                    const fileExtension = extractFileExtensionFromUrl(fileItem);

                    return (
                      <>
                        <Box sx={{ mt: 2, mb: 2 }} key={fileIndex}>
                          <a href={fileItem} download>
                            <li className='raf-activity__file'>
                              <FileIcon
                                mimeType='application/pdf'
                                filename={fileName}
                              />
                              {fileName}
                            </li>
                          </a>
                        </Box>
                      </>
                    );
                  }
                )}
              </ol>
            )}
            {activity.attachments?.images?.length > 0 ? (
              <>
                <Gallery images={activity.attachments?.images} />
              </>
            ) : null}
            {activity.attachments?.videos?.length > 0
              ? activity.attachments?.videos.map((item: any, index: number) => {
                  return (
                    <>
                      {/* DEMO VIDEO src='//embed.api.video/vod/vi54sj9dAakOHJXKrUycCQZp' */}
                      <Box sx={{ mt: 5 }} key={index}>
                        <iframe
                          src={activity.attachments?.videos[0]}
                          width='100%'
                          height='350px'
                          frameBorder='0'
                          allowFullScreen
                        ></iframe>
                      </Box>
                    </>
                  );
                })
              : null}
          </CardContent>
          <CardActions>
            <Stack
              direction='row'
              justifyContent='space-around'
              alignItems='center'
              sx={{
                width: '100%',
                borderTop: 1,
                borderBottom: 1,
                borderColor: palette.primary.main,
              }}
            >
              <TigerLikeButton activity={activity} />

              <Button
                onClick={handleExpandClick}
                startIcon={<InsertCommentIcon />}
              >
                Comments
              </Button>
              <Button startIcon={<ReplyIcon />} onClick={handleMainPostReply}>
                Reply
              </Button>
            </Stack>
          </CardActions>
          <Collapse in={expanded} timeout='auto' unmountOnExit>
            <CardContent className='tiger-comments-thread'>
              <CommentList
                activityId={activity.id}
                reverseOrder={true}
                CommentItem={({ comment }) => {
                  return (
                    <div>
                      <TopLevelCommentItem comment={comment} />
                    </div>
                  );
                }}
              />
              <TigerCommentField
                activity={activity}
                placeholder='Write a comment...'
              />
              {/* <Typography variant='caption' display='block' gutterBottom>
                TEMP NOTE: Tried placing post button many different ways. This
                looked best(??)
              </Typography> */}
            </CardContent>
          </Collapse>
        </Card>
        {/* <Box sx={{ minHeight: '100px' }}>.</Box> */}
      </>
    );
  } else {
    return (
      <></>
      // <Alert severity='info' sx={{ marginTop: 3, marginBottom: 3 }}>
      //   Support for Event and Button posts coming soon!
      // </Alert>
    );
  }
}
